<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="工种名称">
          <el-input placeholder="请输入工种名称" v-model="formInline.search">
          </el-input>
        </el-form-item>

        <el-form-item label="管理局">
          <el-select
            v-model="formInline.ad_bureau_id"
            placeholder="请选择管理局"
            @change="selectOne"
          >
            <el-option
              v-for="(item, index) in adBureauArr"
              :key="index"
              :label="item.name"
              :value="item.ad_bureau_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加工种</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="name" label="工种名称"></el-table-column>

            <el-table-column label="工种图片">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.image && scope.row.image.length > 0"
                  :src="scope.row.image[0].file_path"
                  alt="工种图片"
                  style="width: 100px; height: auto;"
                />
              </template>
            </el-table-column>

            <el-table-column prop="intro" label="工种简介"></el-table-column>

            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add
      :open_add="open_add"
      v-if="open_add"
      @close="closeAdd"
      :ad_bureau_id="formInline.ad_bureau_id"
    ></Add>
    <Edit
      :open_add="open_edit"
      :profession_id="profession_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import ProfessionApi from "@/api/profession.js";
import Ad_bureauApi from "@/api/ad_bureau.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      // fileCodeToName: {
      //   // 英文 code 到中文名称的映射
      //   doc: "文档",
      //   pdf: "PDF",
      //   img: "图片",
      //   vid: "视频",
      //   oth: "其他"
      // },
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        ad_bureau_id: 0
      },

      open_add: false,
      open_edit: false,
      profession_id: "",
      dialogVisible: false,
      adBureauArr: []
    };
  },
  created() {
    /*获取列表*/
    this.getAdBureau();
  },
  methods: {
    getAdBureau() {
      let self = this;
      let Params = {};
      self.loading = true;
      Ad_bureauApi.listx(Params, true)
        .then(data => {
          self.loading = false;
          self.adBureauArr = data.data;
          self.formInline.ad_bureau_id = self.adBureauArr[0].ad_bureau_id;

          this.getTableList();
        })
        .catch(error => {});
    },

    selectOne() {
      let self = this;

      this.getTableList();
    },

    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //工种标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.ad_bureau_id = self.formInline.ad_bureau_id;
      self.loading = true;
      ProfessionApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.profession_id = row.profession_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          ProfessionApi.del(
            {
              profession_id: row.profession_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/profession/index/index.vue